export { default, MessageType } from './Message2';
